module.exports = __webpack_public_path__ + "static/media/Steppr loyalty and gifting - Crystals Healing.cd8060f7.webp";